import { isEmpty, isFunction, isNil } from 'lodash';

import { GLOBAL_DND_COMP_SHOW_LOADER$ } from '../constants/xnx-dnd.subjects';

export function withDndGlobalLoader(compKey: string) {
  return <T>(
    target: {},
    propertyKey: string | symbol,
    descriptor: TypedPropertyDescriptor<T>,
  ): TypedPropertyDescriptor<T> => {
    const originalMethod = descriptor.value;

    if (!isFunction(originalMethod)) {
      throw new TypeError(
        `@withDndGlobalLoader() decorator can be applied only for methods.`,
      );
    }

    if (isEmpty(compKey)) {
      throw new TypeError(
        `@withDndGlobalLoader() need valid compKey(should not be empty).`,
      );
    }

    if (isNil(GLOBAL_DND_COMP_SHOW_LOADER$)) {
      throw new TypeError(
        `@withDndGlobalLoader() need valid GLOBAL_DND_COMP_SHOW_LOADER$ property.`,
      );
    }

    const wrapper = async function (...params: any[]): Promise<any> {
      setTimeout(() => {
        GLOBAL_DND_COMP_SHOW_LOADER$.next({
          key: compKey,
          show: true,
        });
      }, 0);

      let res;
      try {
        res = await originalMethod.apply(this, params);
      } finally {
        GLOBAL_DND_COMP_SHOW_LOADER$.next({
          key: compKey,
          show: false,
        });
      }

      return res;
    };

    return {
      ...descriptor,
      value: wrapper as any,
    };
  };
}
